import axios from 'axios';

const RAILWAY_BACKEND = 'https://workshop-management-backend-production.up.railway.app/api';
const MOJI_BACKEND = 'https://api.moji.org.in/api';

// Determine API base URL from environment or auto-detect.
// Note: Vite inlines env vars at BUILD time — .env is gitignored, so
// VITE_API_URL must be set in the build environment (CI / hosting env vars),
// otherwise it's undefined in the deployed bundle.
let API_BASE = (import.meta.env.VITE_API_URL || '').trim();

if (!API_BASE) {
  const hostname = window.location.hostname;

  // Strategy 1: Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    API_BASE = `http://${hostname}:5000/api`;
  }
  // Strategy 2: Any moji.org.in subdomain (moji.org.in, www., app.) → moji backend
  else if (hostname === 'moji.org.in' || hostname.endsWith('.moji.org.in')) {
    API_BASE = MOJI_BACKEND;
  }
  // Strategy 3: Vercel previews/production → Railway backend
  else if (hostname.includes('vercel.app')) {
    API_BASE = RAILWAY_BACKEND;
  }
  // Strategy 4: Unknown deployment → same-origin /api (reverse-proxy friendly).
  // Never guess :5000 — HTTPS custom domains can't reach it (closed port / mixed content).
  else {
    API_BASE = '/api';
  }
}

console.log(`🔗 API Base URL: ${API_BASE}`);

const api = axios.create({ 
  baseURL: API_BASE, 
  timeout: 10000 // Increased timeout for cross-server requests
});

// Add auth token to requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 errors (session expired)
api.interceptors.response.use(
  res => res,
  err => {
    // Organization suspended / expired (Super Admin) → logout with message
    if (err.response?.status === 403 && err.response?.data?.org_blocked && !err.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
      sessionStorage.setItem('org_blocked_message', err.response.data.message || 'Account blocked');
      window.location.href = '/login';
    }
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
